import React, { useEffect } from 'react'
import Slider from '@material-ui/core/Slider'
import { makeStyles } from '@material-ui/core/styles'

import isNil from 'lodash/isNil'

import * as config from 'styles/tailwind.config'

export interface IMark {
  value: number
  label?: string
}

interface IProps {
  label: string
  min?: number
  max?: number
  step?: number
  marks?: IMark[]
  unit?: string
  value?: number
  defaultValue?: number
  onChange: (value: number | null) => void
}

interface IStyleProps {
  isActive: boolean
}

const useStyles = makeStyles({
  root: {
    color: (props: IStyleProps) =>
      props.isActive ? config.theme.colors.brand.primary : config.theme.colors.black,
  },
  track: {
    height: 1,
  },
  rail: {
    opacity: 1,
    height: 1,
  },
  mark: {
    display: 'none',
  },
})

const CustomSlider: React.FC<IProps> = (props) => {
  const { label, min, max, step, marks, unit, defaultValue, value } = props

  const [currValue, setValue] = React.useState<number>(defaultValue || 0)

  const handleChange = (e: React.ChangeEvent<{}>, newValue: number | number[]) => {
    setValue(Number(newValue))
    props.onChange(isAllValue(Number(newValue)) ? null : Number(newValue))
  }

  const isAllValue = (value: number) => !isNil(min) && value === -1

  const isActive = () => props.defaultValue !== currValue

  const renderValue = () => (isAllValue(currValue) ? 'Alle' : currValue)

  const removeDuplicateMarks = (marks: IMark[] | undefined) => {
    if (isNil(marks)) return marks

    return marks.reduce((uniqueMarks: IMark[], o) => {
      if (!uniqueMarks.some((obj) => obj.value === o.value)) {
        uniqueMarks.push(o)
      }
      return uniqueMarks
    }, [])
  }

  useEffect(() => {
    if (value !== undefined) {
      setValue(value)
    }
  }, [value])

  const classes = useStyles({
    isActive: isActive(),
  })

  return (
    <>
      <label
        style={{
          height: 28,
          marginBottom: 3,
        }}
        className="flex items-end font-500 text-10 text-black uppercase tracking-1.5 leading-14"
      >
        {label}
      </label>
      <Slider
        classes={classes}
        value={currValue}
        onChange={handleChange}
        step={!isNil(marks) ? null : step ? step : 1}
        marks={removeDuplicateMarks(marks)}
        min={min}
        max={max}
      />
      <span
        style={{
          display: 'block',
          marginTop: -3,
        }}
        className={`font-400 text-13 ${
          isActive() ? 'text-brand-primary' : 'text-black'
        } tracking-0.1`}
      >
        {renderValue()} {unit}
      </span>
    </>
  )
}

export default CustomSlider
